import {
  RESET_UPDATE_PRM_DATA,
  UPDATE_PRM_DATA_ERROR,
  UPDATE_PRM_DATA_LOADING,
  UPDATE_PRM_DATA_SUCCESS,
} from "../type/Constant";

let initialState = {
  error: false,
  success: false,
  loading: false,
  errors: [],
  data: null,
};

export default function editPrmReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PRM_DATA_LOADING:
      return { ...state, error: false, loading: true, success: false };
    case UPDATE_PRM_DATA_SUCCESS:
      return {
        ...state,
        error: false,
        success: true,
        loading: false,
        message: action.msg,
      };
    case UPDATE_PRM_DATA_ERROR:
      return {
        ...state,
        error: true,
        success: false,
        loading: false,
        errors: action.errors,
      };
    case RESET_UPDATE_PRM_DATA:
      return {
        ...state,
        error: false,
        success: false,
        loading: false,
        errors: [],
      };
    default:
      return state;
  }
}
